import React, {
  useContext,
  useEffect,
  useState,
} from "react";

import {
  Container,
  Card,
  Form,
  Button,
  Spinner,
} from "react-bootstrap";

import {
  ArrowLeft,
  Send,
  Pencil,
  Trash2,
  Save,
} from "lucide-react";

import {
  useNavigate,
  useParams,
} from "react-router-dom";

import "../../../assets/css/admin/supportticket/chatpage.css";
import AppContext from "../../../context/AppContext";

import axios from "axios";
import Swal from "sweetalert2";
import Navbar from "../../../components/user/navbar/Navbar";
import SimpleBanner from "../../../components/user/general/SimpleBanner";
import Footer from "../../../components/user/footer/Footer";
import MarqueeBanner from "../../../components/user/Marqueebanner/Marqueebanner";

const ChatInCustomer = () => {
  const [messages, setMessages] =
    useState([]);

  const { baseUrl,regTpChecker } =
    useContext(AppContext);

  const [
    selectedMessageId,
    setSelectedMessageId,
  ] = useState(null);

  const [
    idToUpdateDeleteMessage,
    setIdToUpdateDeleteMessage,
  ] = useState("");

  const [
    addUploadLoading,
    setAddUploadLoading,
  ] = useState(false);

  const [
    loadingEditId,
    setLoadingEditId,
  ] = useState(null);
    const [errorMessage, setErrorMessage] = useState("");

  const [
    loadingDeleteId,
    setLoadingDeleteId,
  ] = useState(null);

  const [message, setMessage] =
    useState("");

  const navigate =
    useNavigate();

  const { id } =
    useParams();

  // ================= SEND MESSAGE =================
  const sendMessage = () => {
    const formData =
      new FormData();

    formData.append(
      "tphelpsupport_id",
      id
    );

    formData.append(
      "message",
      message
    );

    formData.append(
      "sender",
      "customer"
    );

    axios
      .post(
        `${baseUrl}/customer/chat/sendMessage`,
        formData,
        {
          headers: {
            "Content-Type":
              "multipart/form-data",
          },
        }
      )
      .then((response) => {
        console.log(
          response.data
        );

        setAddUploadLoading(
          false
        );

        viewAllUploadedMessage();

        resetForm();

        Swal.fire({
          icon: "success",
          title: "Success",
          text:
            "Message sent successfully",
        });
      })
      .catch((err) => {
        console.log(
          err.response?.data
        );

        setAddUploadLoading(
          false
        );
      });
  };

  // ================= VIEW MESSAGE =================
  const viewAllUploadedMessage =
    () => {
      axios
        .get(
          `${baseUrl}/customer/chat/viewAllUploadedMessage/${id}`
        )
        .then((response) => {
          console.log(
            response.data
          );

          setMessages(
            response.data
              .message
          );
        })
        .catch((error) => {
          console.log(
            error.response
              ?.data
          );
        });
    };

  // ================= UPDATE MESSAGE =================
  const updateMessage = () => {
    const formData =
      new FormData();

    formData.append(
      "id",
      idToUpdateDeleteMessage
    );

    formData.append(
      "tphelpsupport_id",
      id
    );

    formData.append(
      "message",
      message
    );

    formData.append(
      "sender",
      "customer"
    );

    axios
      .post(
        `${baseUrl}/customer/chat/updateMessage`,
        formData,
        {
          headers: {
            "Content-Type":
              "multipart/form-data",
          },
        }
      )
      .then(() => {
        viewAllUploadedMessage();

        resetForm();

        setAddUploadLoading(
          false
        );
      })
      .catch((err) => {
        console.log(err);

        setAddUploadLoading(
          false
        );
      });
  };

  // ================= DELETE MESSAGE =================
  const deleteMessage = (
    idToDelete
  ) => {
    const formData =
      new FormData();

    formData.append(
      "id",
      idToDelete
    );

    axios
      .post(
        `${baseUrl}/customer/chat/deleteMessage`,
        formData
      )
      .then(() => {
        viewAllUploadedMessage();

        setAddUploadLoading(
          false
        );
      })
      .catch((err) => {
        console.log(err);

        setAddUploadLoading(
          false
        );
      });
  };

  // ================= RESET =================
  const resetForm = () => {
    setMessage("");

    setIdToUpdateDeleteMessage(
      ""
    );

    setSelectedMessageId(
      null
    );

    setLoadingEditId(
      null
    );

    setLoadingDeleteId(
      null
    );

    setAddUploadLoading(
      false
    );
  };

  useEffect(() => {
    viewAllUploadedMessage();
  }, [id]);

  return (
    <>
    <MarqueeBanner />
      <Navbar />
      

      <Container
        fluid
        className="ticket-chat-wrapper"
      >
         <SimpleBanner
        // path={"Home > All Deals"}
        title="Support & Disputes"
        subtitle="Because the Best Things Deserve to Wait."
        breadcrumbs={[
          { label: "Home", href: "/" },
          { label: "support ticket", href: "/support-tickets" },
          { label: "chat", href: "/customer-chat/:id" },
          //   { label: "wishlist Details", current: true },
        ]}/>
        {/* HEADER */}
        <div className="ticket-chat-header">
          <button
            className="back-btn"
            onClick={() =>
              navigate(-1)
            }
          >
            <ArrowLeft
              size={18}
            />
          </button>

          <div>
            <h3 className="chat-title">
              Customer Support
            </h3>

            <p className="chat-subtitle">
              Chat regarding
              your support
              ticket.
            </p>
          </div>
        </div>

        {/* CARD */}
        <Card className="chat-card">
          <div className="chat-top">
            Chat — {id}
          </div>

          {/* MESSAGES */}
          <div className="messages-wrapper">
            {messages.map(
              (msg) => (
                <div
                  key={msg.id}
                  className={`message-row ${
                    msg.sender ===
                    "customer"
                      ? "admin-row"
                      : "seller-row"
                  }`}
                  onClick={() =>
                    setSelectedMessageId(
                      msg.id
                    )
                  }
                >
                  <div
                    className={`message-bubble ${
                      msg.sender ===
                      "customer"
                        ? "admin-bubble"
                        : "seller-bubble"
                    }`}
                  >
                    <p>
                      {
                        msg.message
                      }
                    </p>

                    <span>
                      {
                        msg.sender
                      }
                    </span>

                    {/* EDIT DELETE */}
                    {selectedMessageId ===
                      msg.id &&
                      msg.sender ===
                        "customer" && (
                        <div className="d-flex gap-2 mt-2">
                          <Button
                            size="sm"
                            variant="warning"
                            disabled={
                              loadingEditId ===
                              msg.id
                            }
                            onClick={() => {
                              setLoadingEditId(
                                msg.id
                              );

                              setTimeout(
                                () => {
                                  setMessage(
                                    msg.message
                                  );

                                  setIdToUpdateDeleteMessage(
                                    msg.id
                                  );

                                  setLoadingEditId(
                                    null
                                  );
                                },
                                500
                              );
                            }}
                          >
                            {loadingEditId ===
                            msg.id ? (
                              <Spinner
                                animation="border"
                                size="sm"
                              />
                            ) : (
                              <Pencil size={16} />
                            )}
                          </Button>

                          <Button
                            size="sm"
                            variant="danger"
                            disabled={
                              loadingDeleteId ===
                              msg.id
                            }
                            onClick={() => {
                              setLoadingDeleteId(
                                msg.id
                              );

                              deleteMessage(
                                msg.id
                              );
                            }}
                          >
                            {loadingDeleteId ===
                            msg.id ? (
                              <Spinner
                                animation="border"
                                size="sm"
                              />
                            ) : (
                              <Trash2 size={16} />
                            )}
                          </Button>
                        </div>
                      )}
                  </div>
                </div>
              )
            )}
          </div>
            {/* Error Message */}
            {errorMessage && (
              <div className="buyer-error-message">{errorMessage}</div>
            )}

          {/* INPUT */}
          <div className="chat-input-wrapper">
            <Form.Control
              placeholder="Type a message..."
              value={message}
             onChange={(e) => {setMessage(e.target.value)
                setErrorMessage(regTpChecker("message", e.target.value));
              }}
            />

            <Button
              className="send-btn"
              onClick={() => {
                setAddUploadLoading(
                  true
                );

                if (
                  idToUpdateDeleteMessage
                ) {
                  updateMessage();
                } else {
                  sendMessage();
                }
              }}
            >
              {addUploadLoading ? (
                <Spinner
                  animation="border"
                  size="sm"
                />
              ) : idToUpdateDeleteMessage ? (
                <Save size={16} />
              ) : (
                <Send size={16} />
              )}
            </Button>
          </div>
        </Card>
      </Container>

      <Footer />
    </>
  );
};

export default ChatInCustomer;